import { defineStore } from "pinia";

/**
 * store para armazenar informaçoes do componente ooloja
 * configuracoes: atualizado -> se refere a data da ultima atualizacao das configuracoes vindas do servidor
 * @returns {Object}
 * @property {string} menuitem - menu selecionado
 * @property {Object} configuracoes - configuracoes do sistema
 * @property {Object} search - parametros de busca
 * @property {function} setConfiguracoes - atualiza as configuracoes
 * @property {function} setMenuItem - atualiza o menu selecionado
 * @property {function} setSearch - atualiza os parametros de busca
 * @example 
 * import { useStoreOoloja } from '~/stores/ooloja.js'
 * const storeOoloja = useStoreOoloja()
 * storeOoloja.setMenuItem('dashboard')
 * storeOoloja.setConfiguracoes({ atualizado: new Date().getTime(), produto_estoque: true, produto_estoque_bloqueia_venda: true })
 */
export const useStoreOoloja = defineStore("storeOoloja", {
  state: () => {
    return {
      menuitem: "dashboard",
      imagemcapa: "",
      videocapa: {
        video: null,
        videoID: null,
        status: null,
      },
      showVideoCapa: false,
      variacaoAtiva: '',
      configuracoes: {
        atualizado: null,
        produto_estoque: false,
        produto_estoque_bloqueia_venda: false,
        condicoes_parcelamento_status: false
      },
      // erp: {
      //   on: false,
      // },
      bot: {
        on: false,
        bot_produto_descricao_on: false,
      },
      valores: {
        setNovoValorPromocional: false,
        setNovoValor: false,
      },
      search: {
        qr: "",
        pOrder: "id",
        limit: 10,
        fPermissao: "0",
        fStatus: "",
        pDirection: "desc",
        tipo: "site",
      }
    };
  },
  actions: {
    setConfiguracoes(configuracoes) {
      this.configuracoes.atualizado = configuracoes.atualizado ?? this.configuracoes.atualizado;
      this.configuracoes.produto_estoque = configuracoes.produto_estoque ?? this.configuracoes.produto_estoque;
      this.configuracoes.produto_estoque_bloqueia_venda = configuracoes.produto_estoque_bloqueia_venda ?? this.configuracoes.produto_estoque_bloqueia_venda;
      this.configuracoes.condicoes_parcelamento_status = configuracoes.condicoes_parcelamento_status ?? this.configuracoes.condicoes_parcelamento_status;
      this.bot.on = configuracoes.bot_on ?? this.bot.on;
      this.bot.bot_produto_descricao_on = configuracoes.bot_produto_descricao_on ?? this.bot.bot_produto_descricao_on;
    },
    setMenuItem(menuitem) {
      this.menuitem = menuitem;
    },
    setSearch(search) {
      this.search = search;
    },
    setImagemCapa(imagemcapa) {
      this.imagemcapa = imagemcapa;
    },
    setVideoCapa(videocapa) {
      this.videocapa = videocapa;
    },
    setShowVideoCapa(show) {
      this.showVideoCapa = show;
    },
    setVariacaoAtiva(variacaoAtiva) {
      this.variacaoAtiva = variacaoAtiva;
    },
    setNovoValorPromocional(v) {
      this.valores.setNovoValorPromocional = v;
    },
    setNovoValor(v) {
      this.valores.setNovoValor = v;
    },
    setCondicoesParcelamentoStatus(v) {
      this.condicoes_parcelamento_status = v;
    }
  },

  persist: true,
});

export const useStoreOolojaFabricantes = defineStore("storeOolojaFabricantes", {
  state: () => {
    return {
      search: {
        qr: "",
        pOrder: "titulo",
        limit: 10,
        fPermissao: "",
        fStatus: "",
        pDirection: "ASC",
      }
    };
  },
  actions: {
    setSearch(search) {
      this.search = search;
    }
  },

  persist: true,
});

export const useStoreOolojaCadastroClientes = defineStore("storeOolojaCadastroClientes", {
  state: () => {
    return {
      menuitem: "oolojacadastroclientes",
      search: {
        qr: "",
        pOrder: "id",
        limit: 10,
        fPermissao: "",
        fStatus: "",
        pDirection: "desc",
        tipo: "site",
      }
    };
  },
  actions: {
    setMenuItem(menuitem) {
      this.menuitem = menuitem;
    },
    setSearch(search) {
      this.search = search;
    }
  },

  persist: true,
});

export const useStoreOolojaProdutoVariacao = defineStore("storeOolojaProdutoVariacao", {
  state: () => {
    return {
      produtoVariacao: false,
      produtoVariacaoPreco: false,
    };
  },
  actions: {
    setProdutoVariacao(v) {
      this.produtoVariacao = v === true || v === 1 ? true : false;
    },
    setProdutoVariacaoPreco(v) {
      this.produtoVariacaoPreco = v === true || v === 1 ? true : false;
    }
  },

  persist: true,
});